module.exports = __webpack_public_path__ + "images/emoji/fries.18947b5d5b4845de5c5b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/fries.png
// module id = fCnD
// module chunks = 1